import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query';
import { QueryReturnValue } from '~/api/baseFetch/common.type';

type oneClubAPIResponse<T> = {
  data: T; // 在 Network 的 Response
};

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_ONECLUB_API_DOMAIN,
  method: 'POST',
});

export const oneClubFetchBase: BaseQueryFn = async (
  args: string | FetchArgs,
  api,
  extraOptions,
) => {
  const result = (await baseQuery(args, api, extraOptions)) as QueryReturnValue<
    oneClubAPIResponse<unknown>,
    FetchBaseQueryError,
    FetchBaseQueryMeta
  >;

  return result;
};
